<div class="error-container">
  <mat-icon class="error-icon">{{ icon }}</mat-icon>
  <p class="error-message">{{ message }}</p>
</div>




